// src/pages/your-path/CreatePost.js

import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Header from "../../components/header";
import LeftMenu from "../../components/left-menu";
import InquiryPops from "../../components/InquiryPops";

import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Select, MenuItem } from "@mui/material";

import axios from "axios"; // 🔹 NEW: untuk call /inqhistorymediapreview

import { read } from "./api.js";
import { readEmpty } from "./apiEmpty.js";

import "./style.css";

export default function CreatePost() {
  const nowstate = useSelector((state) => state);
  const history = useNavigate();

  // --- ORIGINAL LIST / DATA STATES -----------------------------------------
  const [skip, setSkip] = useState(0); // pagination offset
  const [posts, setPosts] = useState([]); // list of inquiries
  const [isEnd, setIsEnd] = useState("loading.."); // text when data ends / loads
  const [query, setQuery] = useState(""); // search text
  const [searchThis, setsearchThis] = useState("Phone"); // "Phone" or "Nama"

  // --- POPUP STATE ----------------------------------------------------------
  const [selectedInquiry, setSelectedInquiry] = useState(null); // current row
  const [loadingInquiryDetail, setLoadingInquiryDetail] = useState(false); // optional: indicator

  // --------------------------------------------------------------------------
  // ORIGINAL FETCH LOGIC (unchanged)
  // Called whenever skip or query changes
  // --------------------------------------------------------------------------
  useEffect(() => {
    fetchPosts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [skip, query]);

  const fetchPosts = async () => {
    // when there is a search query
    if (query.trim()) {
      try {
        const { data, error } = await read(
          skip,
          query,
          searchThis,
          nowstate.user.sales
        );
        if (error) {
          console.log(error.message);
          return;
        }
        console.log("Fetched (search) /listInquiry results:", data.data);

        if (data.data?.length === 0) {
          setIsEnd("Selesai...");
          return;
        }

        const yoyo = data.data;

        // success: append new items to list
        setPosts((prev) => [...prev, ...yoyo]);
      } catch (error) {
        console.log(error);
      }
    } else {
      // no search query: use readEmpty
      try {
        const { data, error } = await readEmpty(skip, nowstate.user.sales);
        if (error) {
          console.log(error.message);
          return;
        }

        console.log("Fetched (empty) /listInquiryEmpty results:", data);

        if (data?.length === 0) {
          setIsEnd("Selesai...");
          return;
        }

        // success: append new items to list
        setPosts((prev) => [...prev, ...data]);
      } catch (error) {
        console.log(error.message);
      }
    }
  };

  // Used when typing in the search box (same as original)
  const newFetchPosts = async (event) => {
    const value = event.target.value;
    setQuery(value);
    setSkip(0);
    setPosts([]);
    setIsEnd("Loading...");

    if (value.trim()) {
      try {
        const { data, error } = await read(
          0, // reset skip saat search baru
          value,
          searchThis,
          nowstate.user.sales
        );
        if (error) {
          console.log(error.message);
          return;
        }

        if (data.data?.length === 0) {
          setIsEnd("Selesai...");
          return;
        }
        const yoyo = data.data;

        // success: replace list with first page of search results
        setPosts([...yoyo]);
      } catch (error) {
        console.log(error.message);
      }
    } else {
      // query kosong -> balik ke mode "empty list" awal
      try {
        const { data, error } = await readEmpty(0, nowstate.user.sales);
        if (error) {
          console.log(error.message);
          return;
        }

        if (data?.length === 0) {
          setIsEnd("Selesai...");
          return;
        }

        setPosts([...data]);
      } catch (error) {
        console.log(error.message);
      }
    }
  };

  // --------------------------------------------------------------------------
  // HANDLERS
  // --------------------------------------------------------------------------

  // create new inquiry (same as before, still routes to new page)
  async function newInquiry() {
    history("/new-inquiry", { state: { stuff: "new" } });
  }

  // 🔹 NEW: waktu klik row, ambil DETAIL inquiry + HISTORY + MEDIA via /inqhistorymediapreview
  async function editInquiry(post) {
    if (!post || !post._id) {
      setSelectedInquiry(post);
      return;
    }

    try {
      setLoadingInquiryDetail(true);
      console.log("Opening inquiry:", post._id);

      const resp = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/inqhistorymediapreview`,
        {
          params: { inquiryId: post._id },
        }
      );

      console.log("Response /inqhistorymediapreview:", resp.data);

      if (resp.data && resp.data.success && resp.data.data) {
        const backend = resp.data.data;

        const merged = {
          ...post,
          // overwrite Nama / Phone kalau backend punya data lebih update
          Nama: backend.nama ?? post.Nama,
          Phone: backend.phone ?? post.Phone,
          // pakai activities dari backend (sudah ada AdCode, adThumbnailUrl, adVideoUrl)
          activities:
            backend.activities && backend.activities.length > 0
              ? backend.activities
              : post.activities || [],
        };

        console.log(
          "Merged inquiry for popup (with activities):",
          merged
        );

        setSelectedInquiry(merged);
      } else {
        console.warn(
          "/inqhistorymediapreview tidak mengembalikan data yang diharapkan, fallback ke post asli."
        );
        setSelectedInquiry(post);
      }
    } catch (err) {
      console.error("Error fetching /inqhistorymediapreview:", err);
      // fallback: tetap buka popup dengan data yang ada
      setSelectedInquiry(post);
    } finally {
      setLoadingInquiryDetail(false);
    }
  }

  // infinite scroll handler (unchanged)
  const handleScroll = (e) => {
    const { offsetHeight, scrollTop, scrollHeight } = e.target;

    if (offsetHeight + scrollTop >= scrollHeight) {
      setSkip((prev) => posts.length); // next offset = jumlah posts sekarang
    }
  };

  // search box handler
  const handleSearch = (event) => {
    newFetchPosts(event);
  };

  // close the popup
  const handleCloseInquiryPopup = () => {
    setSelectedInquiry(null);
  };

  // --------------------------------------------------------------------------
  // RENDER
  // --------------------------------------------------------------------------

  return (
    <Grid container>
      {/* Left menu */}
      <Grid
        item
        xl={0.5}
        lg={0.7}
        md={0.9}
        sm={3.2}
        className="leftmenucolor"
      >
        <LeftMenu />
      </Grid>

      {/* Main content */}
      <Grid xl={10.8} lg={10.6} md={10.4} sm={8.8}>
        {/* Fixed header */}
        <Grid
          className="boxshadowclass"
          position="fixed"
          width="98%"
          xs={12}
          zIndex="100"
          opacity="1"
        >
          <Header judul="Inquiry List" isi="Daftar semua Inquiry" />
        </Grid>

        {/* Spacer so content isn't hidden by fixed header */}
        <Grid sx={{ mt: 15 }} />

        <Grid sx={{ pl: 15 }}>
          {/* Search controls */}
          <Grid item xs={2}>
            <Select
              fullWidth
              value={searchThis}
              onChange={(event) => setsearchThis(event.target.value)}
            >
              <MenuItem value="Phone">Nomor Telepon</MenuItem>
              <MenuItem value="Nama">Nama Klien</MenuItem>
            </Select>
          </Grid>

          <Grid>
            <Button onClick={newInquiry}>Create +</Button>
            <TextField value={query} onChange={handleSearch} />
          </Grid>

          {/* Table */}
          <Grid container align="center" justify="center" alignItems="center">
            <Paper sx={{ width: "100%", overflow: "hidden" }}>
              <TableContainer
                sx={{ maxHeight: 500, minHeight: 440 }}
                className="min-h-screen h-screen overflow-scroll"
                onScroll={handleScroll}
              >
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Nomor Telepon</TableCell>
                      <TableCell>Nama</TableCell>
                    </TableRow>
                  </TableHead>

                  {/* LISTING */}
                  <TableBody>
                    {posts?.map((post) => (
                      <TableRow
                        key={post._id || post.Phone}
                        hover
                        onClick={() => editInquiry(post)}
                        style={{ cursor: "pointer" }}
                      >
                        <TableCell>
                          <p>{post.Phone}</p>
                        </TableCell>
                        <TableCell>
                          <p>{post.Nama}</p>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>

                  {/* End / loading text */}
                  {/* kamu bisa bungkus ini di <TableRow><TableCell colSpan={2}>{isEnd}</TableCell></TableRow> kalau mau lebih rapi */}
                  {isEnd}
                </Table>
              </TableContainer>
            </Paper>
          </Grid>
        </Grid>

        {/* POPUP WITH INQUIRY DETAILS */}
        {selectedInquiry && (
          <InquiryPops
            open={Boolean(selectedInquiry)}
            handleClose={handleCloseInquiryPopup}
            data={selectedInquiry}
          />
        )}
      </Grid>
    </Grid>
  );
}
